import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { MainLoader } from '../loader/main-loader';

import type { ReactNode } from 'react';
import type { OrganizationSelection } from './types';

type OrganizationSwitchingLoaderProps = {
  organization: OrganizationSelection | null;
};

export function OrganizationSwitchingLoader({ organization }: OrganizationSwitchingLoaderProps) {
  let loader: ReactNode = null;
  if (organization !== null) {
    const label = `Switching to ${organization.name}`;
    loader = (
      <Modal open hideBackdrop aria-label={label}>
        <Box
          data-testid="organization-switching-loader"
          tabIndex={-1}
          sx={{
            position: 'fixed',
            inset: 0,
            bgcolor: 'background.default',
          }}
        >
          <MainLoader loaderText={label} />
        </Box>
      </Modal>
    );
  }
  return loader;
}
